// 系统管理》工艺流程设置界面
import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import Step1 from './components/step1';
import Step2 from './components/step2';
import "./index.scss";

const Pages = ({ history, userInfo }) => {
  // 步骤列表
  const stepList = useMemo(() => [
    {
      name: "厂站选择",
      urlImgActive: "up-active",
      urlImg: "up"
    }, {
      name: "工艺拓扑",
      urlImgActive: "top-active",
      urlImg: "top"
    }
  ], []);
  // 选中的步骤
  const [stepActive, setStepActive] = useState(0);

  // 设置步骤选中值
  const nextStep = (val) => {
    setStepActive(val)
  }

  // 渲染dom
  const renderDom = (n) => {
    switch (n) {
      case 0:
        return <Step1 nextStep={nextStep} />
      case 1:
        return <Step2 nextStep={nextStep} />
      default:
        return <div>跑飘啦~</div>
    }
  };
  return (
    <div className="settingProcess-page">
      {/* <img src={require('@/assets/process_01.jpg')} className="tech-process-img" /> */}
      <div>工艺配置</div>
      <div className="step-container">
        {
          stepList.map((item, index) => {
            return <div className={index == stepActive ? "active" : ""} key={item.urlImgActive}>
              <span>
                <img src={require(`./icon/${index == stepActive ? item.urlImgActive : item.urlImg}.png`)} alt="" />
              </span>
              <span>{item.name}</span>
            </div>
          })
        }
      </div>

      {renderDom(stepActive)}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
